import React from "react";
import { useNavigate } from "react-router-dom";

const Expert = () => {
  const navigate = useNavigate();

  const handleContact = () => {
    navigate("/contact");
  };

  const services = [
    { icon: "🏡", title: "Vastu Consultation" },
    { icon: "🔮", title: "Horoscope Reading" },
    { icon: "🔢", title: "Numerology Reading" },
    { icon: "🃏", title: "Tarot Reading" },
    { icon: "🕉️", title: "Yantra-Mantra-Tantra Therapist" },
    { icon: "💎", title: "Crystal Healer" },
  ];

  return (
    <section className="w-full bg-[#fdfbf7] py-16 px-4 sm:px-6 lg:px-12 xl:px-16 relative overflow-hidden">
      {/* Background soft element for premium spiritual look */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#f3e9dc] rounded-full filter blur-3xl opacity-40 pointer-events-none" />
      
      <div className="w-full max-w-7xl mx-auto flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
        
        {/* Left Side: Premium Image Container */}
        <div className="w-full lg:w-[35%] flex justify-center lg:justify-start">
          <div className="relative group">
            {/* Soft decorative background frame */}
            <div className="absolute inset-0 bg-gradient-to-tr from-[#c29352] to-[#8f5c23] rounded-2xl transform rotate-3 scale-102 opacity-20 group-hover:rotate-1 transition-transform duration-300" />
            
            <div className="relative bg-white p-3 rounded-2xl shadow-xl border border-[#eeddbb]/50 overflow-hidden max-w-[320px] transition-transform duration-300 group-hover:scale-[1.01]">
              <img
                src="/image/img/profile.jpeg"
                alt="Vastu Guru Prof. Kalpesh Sinh"
                className="w-full h-auto object-cover rounded-xl grayscale-[20%] hover:grayscale-0 transition-all duration-300"
              />
            </div>
          </div>
        </div>

        {/* Right Side: Structured Content */}
        <div className="w-full lg:w-[65%] flex flex-col justify-center">
          
          {/* Header Tag & Title */}
          <div className="flex flex-col gap-2 mb-6">
            <div className="flex items-center gap-2 bg-[#f3e9dc] w-fit px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider text-[#8f5c23]">
              <span>☀️</span> Meet Our Spiritual Guide
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold bg-gradient-to-r from-[#8f5c23] to-[#c29352] bg-clip-text text-transparent leading-tight">
              Get Personalized Guidance from Our Expert
            </h2>
          </div>

          {/* Description */}
          <p className="text-gray-600 text-[15px] sm:text-base leading-relaxed mb-8 max-w-2xl">
            Meet <span className="font-semibold text-gray-900 border-b-2 border-[#eeddbb]">Vastu Guru Prof. Kalpesh Sinh</span>, 
            our in-house spiritual guide at <span className="font-semibold text-gray-900">Holly Zolly</span>. 
            With years of experience and deep knowledge of cosmic energies, Vastu, and spiritual healing, 
            he helps individuals create balanced, positive, and harmonious spaces. From Vastu guidance 
            to selecting the right spiritual products, his expertise is dedicated to bringing peace, 
            prosperity, and positive energy into your life.
          </p>

          {/* Services Grid with Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 max-w-2xl">
            {services.map((service, index) => (
              <div 
                key={index} 
                className="flex items-center gap-3 bg-white p-3.5 rounded-xl shadow-sm border border-gray-100 hover:border-[#eeddbb] hover:shadow-md transition-all duration-200 group"
              >
                <div className="w-10 h-10 rounded-lg bg-[#fdfbf7] group-hover:bg-[#f3e9dc] flex items-center justify-center text-xl shadow-inner transition-colors duration-200">
                  {service.icon}
                </div>
                <div className="flex flex-col">
                  <span className="text-[#8f5c23] font-semibold text-[15px] tracking-wide group-hover:text-[#c29352] transition-colors duration-200">
                    {service.title}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* Premium Call to Action Button */}
          <div>
            <button
              onClick={handleContact}
              className="relative inline-flex items-center justify-center bg-[#ff6e40] hover:bg-[#e0562b] text-white font-semibold text-sm tracking-wide py-3.5 px-8 rounded-xl transition-all duration-200 shadow-md hover:shadow-lg active:scale-95 group"
            >
              <span>Book an Appointment</span>
              {/* Subtle arrow animation */}
              <svg 
                className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Expert;